// removed by extract-text-webpack-plugin
module.exports = {"content":"style__content___2zm0X","content--hidden":"style__content--hidden___1uDav"};


//////////////////
// WEBPACK FOOTER
// ./components/EventAccordionContent/style.scss
// module id = 1206
// module chunks = 0